'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'ufo-beam';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e048';
var svgPathData = ['M48 226.7c0 8.4 3.7 18.2 14.1 29.1 10.5 11.1 26.9 22.1 48.9 31.9 44 19.6 106.6 32.3 176.9 32.3s132.9-12.7 176.9-32.3c22.1-9.8 38.4-20.9 48.9-31.9 10.4-10.9 14.1-20.7 14.1-29.1s-3.7-18.2-14.1-29.1c-10.5-11.1-26.9-22.1-48.9-31.9-2.2-1-4.4-1.9-6.6-2.8 .1 2 .1 4 .1 6 0 12.7-5.1 24.9-14.1 33.9-39.4 39.4-102.7 53.6-156.3 53.6s-117-14.2-156.3-53.6c-9-9-14.1-21.2-14.1-33.9 0-2 0-4 .1-6-2.3 .9-4.5 1.9-6.6 2.8-22.1 9.8-38.4 20.9-48.9 31.9-10.4 10.9-14.1 20.7-14.1 29.1z', 'M444.3 202.7c9-9 14.1-21.2 14.1-33.9 0-2 0-4-.1-6 2.3 .9 4.5 1.9 6.6 2.8 22.1 9.8 38.4 20.9 48.9 31.9 10.4 10.9 14.1 20.7 14.1 29.1s-3.7 18.2-14.1 29.1c-10.5 11.1-26.9 22.1-48.9 31.9-44 19.6-106.6 32.3-176.9 32.3s-132.9-12.7-176.9-32.3C89 277.9 72.7 266.9 62.1 255.8 51.7 244.9 48 235.1 48 226.7s3.7-18.2 14.1-29.1c10.5-11.1 26.9-22.1 48.9-31.9 2.2-1 4.4-1.9 6.6-2.8-.1 2-.1 4-.1 6 0 12.7 5.1 24.9 14.1 33.9 39.4 39.4 102.7 53.6 156.3 53.6s117-14.2 156.3-53.6zM128.8 107.8c-13.2 4.1-25.7 8.8-37.3 14-25.7 11.4-48 25.7-64.2 42.7-16.3 17.1-27.4 38.2-27.4 62.2s11 45.1 27.4 62.2c16.2 17 38.5 31.3 64.2 42.7 51.5 22.9 121 36.4 196.4 36.4s144.9-13.5 196.4-36.4c25.7-11.4 48-25.7 64.2-42.7 16.3-17.1 27.4-38.2 27.4-62.2s-11-45.1-27.4-62.2c-16.2-17-38.5-31.3-64.2-42.7-11.6-5.1-24-9.8-37.3-14-24.5-64-86.5-109.4-159.2-109.4S153.4 43.8 128.8 107.8zm281.6 61c-52.7 52.7-192.1 52.7-244.8 0 0-67.6 54.8-122.4 122.4-122.4s122.4 54.8 122.4 122.4zM149.7 388.3c-10.9-7.5-25.8-4.8-33.4 6.1l-72 104c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l72-104c7.5-10.9 4.8-25.8-6.1-33.4zm270.6 33.4l72 104c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4l-72-104c-7.5-10.9-22.5-13.6-33.4-6.1s-13.6 22.5-6.1 33.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUfoBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;